module.exports = __webpack_public_path__ + "static/media/polaroid-8.15941640.png";